export default __webpack_public_path__ + "static/media/vector2.0a4bc332.gif";